module.exports = __webpack_public_path__ + "static/img/wdzt1-6.bfd9cb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-6.png
// module id = 855
// module chunks = 0